import React from 'react';

interface FormCheckboxProps {
  id: string;
  label: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  required?: boolean;
  disabled?: boolean;
}

export default function FormCheckbox({
  id,
  label,
  checked,
  onChange,
  required = false,
  disabled = false
}: FormCheckboxProps) {
  return (
    <div className="flex items-start space-x-3">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 w-4 h-4 text-trust-blue bg-pure-white border border-border-light rounded focus:ring-trust-blue/20 focus:ring-2"
        required={required}
        disabled={disabled}
      />
      <label htmlFor={id} className="text-body text-gray-700 font-inter">
        {label} {required && <span className="text-error-red">*</span>}
      </label>
    </div>
  );
}